import * as React from "react";
import { 
  Grid, 
  LinearProgress, 
  Stack, 
  Typography,
  Button,
  ButtonGroup,
} from "@mui/material";
import {
  LocalShipping,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { TrackingContext } from "../context";
import { useEffect } from "react";
import { CorrispondenteDialog, FilterBar, UploadDialog } from "../components";
import { titlePage, getConfig } from "../utilities";
import CustomPaginationActionsTable from "../components/CustomPaginationActionsTable";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const limit = 100;
const offset = 0;

const listaStato =[
  { value:"CON", text:"Consegnato"},
  { value:"INC", text:" In consegna"},
  { value:"CON", text:"Disitinta"},
  { value:"ALTRI", text:"In lavorazione"},
]


//11/07/2026 signedLinkToken: se valorizzato la pagina gira in modalità "signed link"
//(accesso monouso senza login). Il token viene dal query param ?id ed è propagato a
//tutte le chiamate verso le API .../signedlink?id=<token>.
const Corrispondente = ({ signedLinkToken }) => {
  const { t }                                               = useTranslation("common",{ keyPrefix: 'Corrispondente' })
  const [ pageResetVar, setPageResetVar ]                   = useState( false );
  const [ checkBoxSelection, setCheckBoxSelection ]         = useState( []    );
  const [ isOpen, setIsOpen ]                               = useState( false );
  const [ NPage, setNPage ]                                 = useState( 0     );
  const [ pageOffset, setPageOffset ]                       = useState( 0     );
  const [ uploadPodDialogOpen, setUploadPodDialogOpen ]    = useState( false );
  const [ lastSpedSelected, setlastSpedSelected ]           = useState( ""    );
  const [ lastPrgSelected, setlastPrgSelected ]             = useState( ""    );
  //05/02/2024 Greg: per capire se sto inserendo spedizione singola.
  const [ singleSpedMode, setSingleSpedMode ]               = useState( false );

  const navigate = useNavigate();

  const {
    state: { 
      trackingList, 
      columnsCustom, 
      recordCount, 
      filter, 
      resettaFiltri, 
      azioni,
      confermaConsegnaActive
    },
    getCorrispondenteList,
    aggiornaFiltri,
    resetFiltriCorrisp,
    trackEmail,
    postConsegnato,
    postDataConsegna,
    postUploadPod
  } = useContext( TrackingContext );


  const [reload, setReload] = useState( false );

  //11/07/2026 In modalità signed-link la config va caricata senza login prima di
  //poter chiamare le API; in modalità autenticata è gia presente in localStorage.
  const [ signedConfigReady, setSignedConfigReady ] = useState( !signedLinkToken );

  //19/06/2024 Greg: Lo metto come 'Globale' per il componente in modo da evitare il reset ad ogni rendering
  let podDownloadPathVar = ''

  //11/07/2026 Wrapper che forza il token in nona posizione a prescindere dall'arita
  //con cui i componenti figli (FilterBar / tabella) invocano il metodo lista.
  const loadCorrispondenteList = (
    rif,
    listLimit,
    listOffset,
    nav,
    dataSet,
    recCount,
    reset,
    filterTracking
  ) =>
    getCorrispondenteList(
      rif,
      listLimit,
      listOffset,
      nav,
      dataSet,
      recCount,
      reset,
      filterTracking,
      signedLinkToken
    );

  const resetFiltriBound = () =>
    signedLinkToken ? resetFiltriCorrisp( signedLinkToken ) : resetFiltriCorrisp();

  //11/07/2026 Carica la config senza login quando si arriva da un signed link.
  useEffect(() => {
    if (!signedLinkToken) return;
    const fetchConfig = async () => {
      const conf = await getConfig(window.location.href);
      localStorage.setItem("configurazioni", JSON.stringify(conf));
      setSignedConfigReady(true);
    };
    fetchConfig();
  }, [signedLinkToken]);

  useEffect(() => {
    if (!signedConfigReady) return;
    titlePage("", t("titlePage"));
    loadCorrispondenteList(
      "",
      limit,
      offset,
      navigate,
      [],
      recordCount,
      false,
      filter
    );
  }, [signedConfigReady]);

  const emailActionTrak=(e)=>{
    trackEmail(e)
   }

  const uploadPODAction = (e) => {
    setlastSpedSelected( e?.PrefissoNumeroPratica );
    setlastPrgSelected ( e?.PrgInterno            );

    setUploadPodDialogOpen(true);

  } 


  const confermaConsegnaSingolaAction = (e) => {
    setlastSpedSelected( e?.PrefissoNumeroPratica );
    setlastPrgSelected ( e?.PrgInterno            );
    setIsOpen(true)
    setSingleSpedMode(true);
  } 

  
  const uploadFilePOD = (fileBase64) => {
        postUploadPod( fileBase64, lastPrgSelected, signedLinkToken);
  }


  //14/07/2025 Greg: Implementata possibilità di scaricare il POD
  const downloadPodAction = (params, idElement)  => {
    let path = localStorage.getItem("path");
    let splitPrm = path.split("/");

    //19/06/2024 Greg: Non utilizzo setPodDownloadVar, altrimenti rischio pagine vuota per tempi di esecuzione dell'hook
    podDownloadPathVar = `${splitPrm[0]}//${splitPrm[2]}/pod/${params[idElement]}`

    window.open(
      podDownloadPathVar,
      "_blank",
      "noopener,noreferrer"
    )
    podDownloadPathVar = ''
  }


  const handlePostConfermaConsegna = (dataConsegna, esito) => {

    let prgSpedList = '';

    if ( singleSpedMode !== true){
      checkBoxSelection.forEach((element) => {
        prgSpedList = prgSpedList  + element.PrgInterno + ',';
      });
    }
    else {
      prgSpedList = lastPrgSelected 
    };

    postDataConsegna( dataConsegna, esito, prgSpedList, signedLinkToken );

    setlastSpedSelected("");
    setlastPrgSelected ("");
  } 


  return (
    <>
      <Grid container spacing={2}>
        <Grid container item mr={2} spacing={2} direction={"row"}>
          <Grid item xs={12} md={12} lg={12}>
            <FilterBar
              type             = {true}
              recordCount      = {recordCount}
              filter           = {filter}
              aggiornaFiltri   = {aggiornaFiltri}
              getMethod        = {loadCorrispondenteList}
              resetFiltri      = { resetFiltriBound }
              setViewStatoWeb  = {true}
              setViewAdvFilter = {true}
              setPageResetVar  = {setPageResetVar}
              listStatoWeb     = {listaStato}
              setCounterApi    = {setPageOffset}
              setPage          = {setNPage}
            ></FilterBar>
          </Grid>
        </Grid>
        <Grid item xs={12} md={12} lg={12}>

        <ButtonGroup size={"large"} orientation={"horizontal"}>
          {confermaConsegnaActive && confermaConsegnaActive === true ? (
            <Button
              variant   = "text"
              startIcon = {<LocalShipping />}
              disabled  = {checkBoxSelection.length < 1}
              onClick   = {() =>
                setIsOpen(true)
              }
            >
              { t("ConfermaConsegnato") }
            </Button>
          ):(<></>)}
            <CorrispondenteDialog 
              isOpen            = { isOpen }
              setIsOpen         = { setIsOpen }
              data              = { checkBoxSelection }
              postDatafunc      = { handlePostConfermaConsegna }
              singleSpedMode    = { singleSpedMode }
              setSingleSpedMode = { setSingleSpedMode }
              setlastSped       = { setlastSpedSelected }
              setLastPrg        = { setlastPrgSelected }
            />
          </ButtonGroup>

          {columnsCustom.length > 0 ? (            
            <CustomPaginationActionsTable
              setCheckBoxSelectionPrint = {setCheckBoxSelection} 
              rows             = { trackingList }
              columns          = { columnsCustom }
              limit            = { 100 }
              navigate         = { navigate }
              getMethodForList = { loadCorrispondenteList }
              recordCount      = { recordCount }
              routeDetail      = { "/tracking" }
              idElement        = { "PrgInterno" }
              pageReset        = { pageResetVar }
              actionShow       = { true }
              viewAction = {{
                mail                    : false,
                view                    : true,
                location                : false,
                print                   : false,
                edit                    : false,
                delete                  : false,
                uploadPOD               : true,
                confermaConsegnaSingola : confermaConsegnaActive 
              }}
              /*emailAction={(e)=>emailActionTrak(e)}*/
              filterList                 = { filter }
              resettaFiltri              = { resettaFiltri }
              counterApi                 = { pageOffset }
              setCounterApi              = { setPageOffset }
              page                       = { NPage }
              setPage                    = { setNPage }
              uploadPODAction            = { uploadPODAction }
              confermaConsegnaSingolaAct = {confermaConsegnaSingolaAction}
              downloadAction             = {downloadPodAction}    //14/07/2025 Greg: Implementata possibilità di scaricare il POD
              disablePodDownload         = { !!signedLinkToken }  //11/07/2026 Con signed link il download POD non è cliccabile
              disableView                = { !!signedLinkToken }  //11/07/2026 Con signed link il dettaglio spedizione è disabilitato
            />
          ) : (
            <Stack justifyContent={ "center" } alignContent="center">
              <Typography>{t("loadPage")}</Typography>
              <LinearProgress color="success" />
            </Stack>
          )}
        </Grid>
      </Grid>

      <UploadDialog
        open             = { uploadPodDialogOpen }
        setOpen          = { setUploadPodDialogOpen }
        //testDoc={testDoc}
        postFile         = { uploadFilePOD }
        dialogTitle      = { "Caricamento POD" }
        numRif           = { lastSpedSelected }  
        // ultimare scritture lastspedselected in uplad dialog    
        mode             = { "POD" }     
      />
    </>
  );
};

export default Corrispondente;
